<!-- 案例 -->
<template>
  <div class="case">
    <h4 class="current">
      您的位置：<router-link to="/home">首页 </router-link> &gt;产品与方案 &gt; IPv6 升级改造解决方案
    </h4>
    <div class="article">
      <h5>IPv6 升级改造解决方案</h5>
      <h4 class="smalltit">产品背景</h4>
      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;为贯彻落实党中央、国务院关于建设网络强国的战略部署，加快推进基于互联网协议第六版（IPv6）的下一代互联网规模部署，中共中央办公厅、国务院办公厅于
        2017 年 11 月 26 日印发了《推进互联网协议第六版（IPv6）规模部署行动计划》（厅字【2017】47 号文）。明确用 5 到 10
        年时间，形成下一代互联网自主技术体系和产业生态，建成全球最大规模的 IPv6 商用网络。
      </p>
      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2018 年 3
        月，国资委综合局下发《关于做好互联网协议第六版（IPv6）部署应用有关工作的通知》；2018 年 4 月 25
        日，工业和信息化部下发《关于贯彻落实《推进互联网协议第六版（IPv6）规模部署行动计划》的通知》；2018 年 7 月
        12日，由中央网信办、国家发改委、工信部、中央国资委联合举办的 IPv6 规模部署推进会，再次明确国家推进 IPv6
        规模部署的决心。大会上，正式发布 IPv6 发展监测平台，宣布国家对各个领域 IPv6 监测及考核指标，并定期发布 IPv6
        发展监测报告。
      </p>

      <h4 class="smalltit">IPv6 升级解决方案</h4>
      <img src="@/assets/dianxin5-1.jpg" /><br />
      <img src="@/assets/dianxin5-2.jpg" /><br />
      <img src="@/assets/dianxin5-3.jpg" />

      <h4 class="smalltit">升级改造效益</h4>

      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1、在原有 v4
        网站基础设施、网络结构、应用程序无任何重构的基础上一次性实现网站 IPv4/IPv6
        的主流业务互通、应用迁移，在保证原有基础设施及业务架构不做任何更改的前提下达到“实施过程最快化、效果性能最优化、迁移成本最小化”。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、为所有入网设备真实分配世界范围内唯一的公网 IPv6
        地址，构建无缝连接、完整安全、标识唯一的网络支撑保障，促进我国在下一代互联网尤其是移动互联网领域核心技术和关键设备研发方面的速度，面向终端用户构筑更快捷、更稳定的
        IPv6 网络基础建设。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3、针对需保护的信息资产和重要数据，将 IPv6
        地址分配到每一台设备资产，凭借 IPv6 的唯一标识性，配合 4601
        网络行为管理、应用识别、操作行为审计、大数据分析等功能，构建应用部署于政务专网的，可定位、可管理、可控制、可回溯的效率保障及安全管理体系，提升政务办公效率、保障设备资产及数据信息安全。
      </p>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {}
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
h4.current {
  display: block;
  height: 40px;
  line-height: 30px;
  background: url(../../../assets/currentbg.jpg) repeat-x bottom;
  color: #333;
}
h4.current a:hover {
  color: #e90000;
}
.article h5 {
  display: block;
  text-align: center;
  line-height: 60px;
  font-size: 30px;
  color: #333;
  margin-top: 40px;
}
.article h6 {
  display: block;
  text-align: center;
  font-size: 14px;
  color: #888;
  margin-top: 5px;
  margin-bottom: 30px;
}
.smalltit {
  display: block;
  height: 55px;
  line-height: 55px;
  margin-top: 20px;
  padding-left: 35px;
  background: url(../../../assets/ico01.png) no-repeat left center;
  font-size: 22px;
  color: #e60212;
}
.intro p {
  line-height: 30px;
}
.intro img {
  display: block;
  margin: 0 auto;
}
.article img {
  margin: 0 auto;
  display: block;
  margin-top: 15px;
}
.article p {
  margin-top: 15px;
  line-height: 30px;
  margin: 15px 0;
}
.boldblack {
  color: #333;
  font-weight: bold;
}
.boldred {
  color: #f00;
  font-weight: bold;
}
.font18 {
  font-size: 18px;
}
</style>
